import React, { useEffect, useState } from 'react';
import HandleFrom from './HandleForm';
import { SubmitHandler } from 'react-hook-form';
import { Grid, Link, Stack, Typography } from '@mui/material';
import IndicatorChip from '../common/ActionChip/IndicatorChip';
import EventAvailableOutlinedIcon from '@mui/icons-material/EventAvailableOutlined';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import { TicketCloseFormModel } from '../../models/ticket.model';
import { closeTicket, getTicketClose } from '../../services/ticket.service';
import { useNavigate } from 'react-router-dom';
import { useProject } from '../../context/ProjectContext';
import { useNotification } from '../../context/NotificationContext';


interface TicketCloseProps {
  setBlockScreen: (p: boolean) => void
  ticket_number: string
  action: string
}

export default function TicketClose({ setBlockScreen, ticket_number, action }: TicketCloseProps) {

  const { selectedProject } = useProject()
  const { showNotification } = useNotification();

  const [ticketCloseForm, setTicketCloseForm] = useState<TicketCloseFormModel>({
    ticket_number: ticket_number,
    created_by: {},
    created_date: '',
    closing_cause: '',
    description: '',
    project_code: selectedProject
  })

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    setTicketCloseForm(ticketCloseForm => ({
      ...ticketCloseForm,
      [event.target.name]: event.target.value
    }));
  };

  const handleSelection = (key: string, value: string): void => {
    setTicketCloseForm(ticketCloseForm => ({
      ...ticketCloseForm,
      [key]: value
    }));
  };

  const navigate = useNavigate()

  const initComponent = () => {
    setBlockScreen(true);
    if (action === 'view') {
      Promise.all([getTicketClose(selectedProject, ticket_number)]).then(function (results) {
        setTicketCloseForm(results[0]);
      }).catch((error) => {
        showNotification(error.response.data, 'error');
      });
      setBlockScreen(false);
    }
    else {
      setBlockScreen(false);
    }
  }

  useEffect(initComponent, []);

  const onSubmit: SubmitHandler<TicketCloseFormModel> = () => {
    setBlockScreen(true);
    Promise.all([closeTicket(selectedProject, ticket_number, ticketCloseForm)]).then(function () {
      let path = "/tickets/listing";
      showNotification(<Typography component='span'>
        <i>Ver Cierre </i>
        <Link
          sx={{ color: 'darkblue', fontWeight: 'bold', fontStyle: 'italic' }}
          underline="hover"
          href={`/${selectedProject}/ticket/view/${ticket_number}/2`}
        >
          {ticket_number}
        </Link>
      </Typography>)
      setBlockScreen(false);
      navigate(path)
    }).catch((error) => {
      showNotification(error.response.data.error, 'error')
      setBlockScreen(false);
    });
  };

  return (
    <React.Fragment>
      {(action === 'view') && (ticketCloseForm.created_by) && (
        <Grid container marginTop={'2vh'} rowSpacing={'2vh'} columnSpacing={'2vw'}>

          <Grid item xs={12} md={'auto'}>
            <Stack direction="row" spacing={'0.5vw'} rowGap={1} flexWrap={'wrap'}>
              <IndicatorChip
                label={`Cerrado por ${ticketCloseForm.created_by?.label}`}
                iconDecoration={<PersonOutlineOutlinedIcon />}
              />
              <IndicatorChip
                label={`Cierre ${ticketCloseForm.created_date}`}
                iconDecoration={<EventAvailableOutlinedIcon />}
              />

            </Stack>
          </Grid>
        </Grid>
      )}

      <HandleFrom
        action={action}
        ticketCloseForm={ticketCloseForm}
        onSubmit={onSubmit}
        handleChange={handleChange}
        handleSelection={handleSelection}
        selectedProject={selectedProject ? selectedProject : ticket_number.substring(0, 2)}
      />

    </React.Fragment>
  );
}